import type { ReactNode } from 'react';
import { Time } from './display';
import type { Tone } from './status';

export interface TimelineEntry {
  id: string;
  at: string | null | undefined;
  title: ReactNode;
  /** Badges or actor info next to the title. */
  meta?: ReactNode;
  body?: ReactNode;
  /** Marker: neutral ink (default), faint (routine/system) or accent (needs you). */
  tone?: Tone;
}

/** Chronological list of semantic articles. Order is the caller's; nothing is re-sorted here. */
export function Timeline({ entries, label }: { entries: readonly TimelineEntry[]; label: string }) {
  return (
    <ol className="timeline" aria-label={label}>
      {entries.map((e) => (
        <li key={e.id} className="timeline-item">
          <span className="timeline-marker" data-tone={e.tone ?? 'neutral'} aria-hidden />
          <article>
            <header className="timeline-head">
              <span className="strong">{e.title}</span>
              {e.meta}
              <span className="timeline-time">
                <Time value={e.at ?? null} relative={false} emptyLabel="Time unknown" />
              </span>
            </header>
            {e.body ? <div className="timeline-body">{e.body}</div> : null}
          </article>
        </li>
      ))}
    </ol>
  );
}
